import React, { PureComponent } from 'react';
import mergeClassNames from 'classnames';

class Card extends PureComponent {
    render() {
        const {
            children,
            border,
            marginBottom,
            sm,
            ...props
        } = this.props;

        const classNames = mergeClassNames({
            ['card']: true,
            ['mb-' + marginBottom]: true,
            ['border-' + border]: border ? true : false
        });

        const classNamesBody = mergeClassNames({
            ['card-body']: true,
            ['py-0_5 px-1']: !!sm,
            ['py-1_25 py-lg-1_5 px-1 px-md-1_5 px-lg-2']: !sm
        });

        return (
            <div className={classNames} {...props}>
                <div className={classNamesBody}>
                    {children}
                </div>
            </div>
        );
    }
}

Card.defaultProps = {
    marginBottom: 2,
    sm: false
};

export default Card;
